<template>
  <div class="custom-tooltip">
    <table class="list-report">
      <!-- History Header (always visible) -->
      <thead class="history-header">
        <tr>
          <th colspan="3">
            Details
          </th>
        </tr>
        <tr>
          <th>Date/Time</th>
          <th>Status</th>
          <th>Remarks</th>
        </tr>
      </thead>

      <!-- History Rows (render only if data exists) -->
      <tbody v-if="calcData.history && calcData.history.length">
        <tr
          v-for="(data, i) in calcData.history"
          :key="i"
        >
          <td>{{ data.dt }}</td>
          <td>{{ data.status }}</td>
          <td>{{ data.remarks }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { computed, onBeforeMount } from 'vue';

export default {
  name: 'RegisterToolTip',
  setup(props) {
    let exception = null;

    const calcData = computed(() => {
      const retval = {};
      const attData = props.params.data.attendanceData;

      if (attData?.exception) {
        const newData = attData?.exception;

        retval.history = newData.map((v) => ({
          dt: v.edit_timestamp ? new Date(v.edit_timestamp + 'Z').toLocaleString() : '--',
          status: v.attendance_code ?? '--',
          remarks: v.description ?? '--',
        }));
      }

      return retval;
    });

    onBeforeMount(() => {
      exception = props.params.value;
    });

    return { exception, calcData };
  },
};
</script>

<style scoped>
.custom-tooltip {
  display: inline-flex;
  flex-direction: column;
  background: #ffffff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  font-size: 0.75rem;
  color: #212121;
}

.list-report {
  width: 100%;
  border-collapse: collapse;
}

.list-report th,
.list-report td {
  border: 1px solid #b0b0b0;
  padding: 6px 10px;
  text-align: center;
}

.history-header th {
  background-color: #6e6e6e;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 0.7rem;
}
</style>
